<!--
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-11-17 15:48:09
 * @LastEditors: zhangyuan zhangyuan@cheyipai.com
 * @LastEditTime: 2022-12-05 17:13:34
 * @FilePath: /report-template/src/views/reportConfirm/components/reportItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="reportConfirm_reportPicItem">
        <reportComfirmTitle titleTxt='车辆照片' :picNum='renderData.length' goPageType='cheliangzhaopian'>
        </reportComfirmTitle>
        <div class='reportConfirm_reportPicItem_box'>
            <ul class="reportConfirm_reportPics">
                <li class='reportConfirm_reportPics_item'
                v-for='item in renderData' :key='item.photoCode'>
                    <img :src="item.photoPath" alt="" srcset="">
                    <p>{{item.photoName}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue'
import { Icon } from 'scvant';
import reportComfirmTitle from '../title.vue'

export default {
    name: 'carPhotoList',
    components: {
        [Icon.name]: Icon,
        reportComfirmTitle
    },
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    }
}
</script>
<style scoped lang='less'>
.reportConfirm_reportPicItem {
    background: #F7F8FA;
    border-radius: .08rem;
    padding: .16rem;
    margin-top: .2rem;
    padding-right:0;
    padding-bottom: .08rem;
    .reportComfirm_title {
        margin-right: .16rem;
    }
    .reportConfirm_reportPicItem_box {
        overflow-x: auto;
        padding-bottom: .08rem;
        .reportConfirm_reportPics  {
            display: flex;
            flex-wrap: nowrap;
            margin-top: .16rem;
            .reportConfirm_reportPics_item {
                flex-shrink: 0;
                width: .75rem;
                margin-right: .06rem;
                &:last-child {
                    margin-right: 0;
                }
                img {
                    display: block;
                    width: 100%;
                    height: .56rem;
                    border-radius: .04rem;
                }
                p {
                    font-size: .1rem;
                    margin-top: .08rem;
                    text-align: center;
                }
            }
        }
    }
}

</style>